<template>
  <div v-if="this.plans.length > 0">
    <v-layout row wrap v-if="this.plans.length <= 3">
      <v-flex xs12 hidden-md-and-down>
        <table-plans :plans="plans" :limitsText="limitsText" :selected="selected" :currPrefix="currPrefix" @selectPlan="doSelectPlan"></table-plans>
      </v-flex>
      <v-flex xs12 hidden-lg-and-up>
        <responsive-plans :plans="plans" :limitsText="limitsText" :selected="selected" :currPrefix="currPrefix" :iconType="iconType" @selectPlan="doSelectPlan"></responsive-plans>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <responsive-plans :plans="plans" :limitsText="limitsText" :selected="selected" :currPrefix="currPrefix" :iconType="iconType" @selectPlan="doSelectPlan"></responsive-plans>
      </v-flex>
    </v-layout>
  </div>
  <div v-else>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-alert :value="true" type="warning">There is no plan that fits the criteria.</v-alert>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { APP_TOGGLE_MENU } from '@/store/types'
import TablePlans from './TablePlans'
import ResponsivePlans from './ResponsivePlans'
export default {
  methods: {
    /**
     * Will emit an object that consist of the follow:
     * value: planNo
     * proceed: true/false (to let parent know if they should proceed)
     */
    doSelectPlan(obj) {
      this.$emit('selectPlan', obj)
    }
  },
  beforeMount() {
    // For best viewing pleasure, we will collapse the left menu if there are too many plans
    if (this.plans.length > 2) {
      this.$store.commit(APP_TOGGLE_MENU, false)
    }
  },
  props: {
    /**
     * Plan Object should consist of the following
     * - planNo
     * - planDesc
     * - limits (Object key: value)
     * - premium (Object):
     *  - premiumPayable
     */
    plans: {
      type: Array,
      default: () => []
    },
    /**
     * Each Limit Text should consist of the following
     * - Label
     * - Value
     */
    limitsText: {
      type: Array,
      default: () => []
    },
    /**
     * Selected planNo
     */
    selected: {
      type: String,
      default: ''
    },
    /**
     * Eg: S$
     */
    currPrefix: {
      type: String,
      default: ''
    },
    /**
     * Ref const/underwriting
     */
    iconType: {
      type: String,
      default: ''
    }
  },
  components: {
    TablePlans,
    ResponsivePlans
  }
}
</script>

<style lang="scss">
@import "../../../../assets/scss/base.scss";

.planTable {
  // Overwrite default height of 48px from material
  tbody td {
    height: 0px !important;
    vertical-align: top;
  }
  thead .planSelected {
    border-top: 3px solid $primary;
  }
  .planHeader {
    .planHeaderCol {
      position: relative;
      padding-top: 12px;
      padding-bottom: 12px;
    }
    .limitTxtHeader {
      min-width: 300px;
    }
    .planTitle {
      font-size: 1.5em;
    }
    .planCurr {
    }
    .planPrice {
      font-size: 1.8em;
    }
    .selectedInfo {
      width: 100%;
      position: absolute;
      top: -55px;
      text-align: center;
    }
  }
  .planBody {
    .planCol {
      // Dont apply this on col, they (vuetify) has default padding for their col
      padding-top: 12px;
      padding-bottom: 12px;
    }
    tr.titleRow {
      background: #eee;
    }
  }
}

.ribbon {
  // http://www.cssportal.com/css-ribbon-generator/
  position: absolute;
  right: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}

.ribbon span {
  font-size: 12px;
  font-weight: 600;
  color: #FFF;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  width: 100px;
  display: block;
  background: $secondary;
  background: linear-gradient($secondary 0%, $secondary 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 19px;
  right: -21px;
}

.ribbon span::before {
  content: "";
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid $secondary;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid $secondary;
}

.ribbon span::after {
  content: "";
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid $secondary;
  border-bottom: 3px solid transparent;
  border-top: 3px solid $secondary;
}

</style>
